
<template>
  <div class="boxbgcolor" style="overflow-y: scroll">
    <div class="content-left">
      <AreaTree ref="areaTree" :moduleName="moduleName" v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right" ref="contentRight">
      <div class="chart-info">
        <span class="chart-legend"></span>
        <span>总额（追缴额+收费额）</span>
      </div>
      <div class="chart-show">
        <div class="chart-show-container chart-show-day">
          <template>
            <div
              v-if="!hasDayData"
              ref="myCharts"
              class="no-data"
              style="width:100%;height:90%;"
            >暂无数据</div>
            <div v-else id="myChartDay" ref="myCharts" style="width:100%;height:90%;"></div>
          </template>

          <div class="search">
            <label>查询日期:</label>
            <el-date-picker
              clearable
              class="search-input"
              value-format="yyyy-MM-dd"
              v-model="search.day"
              type="date"
            ></el-date-picker>
            <button
              type="button"
              @click="dayEcharts()"
              class="search-button btn btn-primary"
              id="search_btn"
            >查询</button>
          </div>
        </div>
        <div class="chart-show-container chart-show-month">
          <template>
            <div
              v-if="!hasMonthData"
              ref="myCharts"
              class="no-data"
              style="width:100%;height:90%;"
            >暂无数据</div>
            <div v-else id="myChartMonth" ref="myCharts" style="width:100%;height:90%;"></div>
          </template>
          <div class="search">
            <label>查询日期:</label>
            <el-date-picker
              clearable
              class="search-input"
              value-format="yyyy-MM"
              v-model="search.month"
              type="month"
            ></el-date-picker>
            <button
              type="button"
              @click="monthEcharts()"
              class="search-button btn btn-primary"
              id="search_btn"
            >查询</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import AreaTree from "../../commons/areaTree";
import { chargeRanking } from "@/api/url";
export default {
  data() {
    return {
      moduleName: "parking",
      hasDayData: false,
      hasMonthData: false,
      myChartInstanse: null,
      myChartMonthInstanse: null,
      search: {
        day: "",
        month: ""
      },
      treeData: {
        groupId: ""
      },
      myChartDayData: [],
      myChartDay: {
        // 数据
        dataset: {
          source: []
        },
        grid: {
          left: "30%"
        },
        tooltip: {
          formatter: function(params, ticket, callback) {
            console.log(params.value);
            let v = params.value;
            return "追缴额:" + v.arrears + "元+收费额:" + v.realMoney + "元";
          }
        },
        xAxis: {
          name: "单位:元",
          nameGap: 5,
          nameTextStyle: {
            fontSize: 10
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: ["#007AF9"]
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLabel: {
            rotate: -60,
            formatter: function(value) {
              var texts = [];
              texts.push(value);
              return texts;
            }
          }
        },
        yAxis: {
          name: "收费员排名(日)",
          nameGap: 5,
          nameLocation: "start",
          inverse: true,
          nameTextStyle: {
            fontSize: 10
          },
          axisTick: {
            alignWithLabel: true
          },
          type: "category",
          axisLabel: {
            formatter: function(value, index) {
              let i = index + 1;
              return "{a|" + i + "}" + "{b|" + value + "}";
            },
            rich: {
              a: {
                backgroundColor: "#3395FA",
                align: "center",
                width: 16,
                height: 16,
                color: "white",
                borderRadius: 8,
                lineHeight: 16,
                fontSize: 10
              },
              b: {
                padding: [0, 5]
              }
            }
          }
        },
        series: [
          {
            type: "bar",
            barWidth: 16,
            label: {
              normal: {
                show: true,
                position: "right",
                textStyle: {
                  color: "#282828", //color of value
                  fontSize: 12
                },
                formatter: "{@total}元"
              }
            },
            itemStyle: {
              normal: {
                color: "#3395FA"
              }
            },
            encode: {
              // 将 "total" 列映射到 X 轴。
              x: "total",
              // 将 "name" 列映射到 Y 轴。
              y: "name"
            }
          },
          {
            type: "line",
            smooth: true,
            itemStyle: {
              color: "#FF6600"
            },
            encode: {
              // 将 "total" 列映射到 X 轴。
              x: "total",
              // 将 "name" 列映射到 Y 轴。
              y: "name"
            }
          }
        ]
      },
      myChartMonthData: [],
      myChartMonth: {
        // 数据
        dataset: {
          source: []
        },
        grid: {
          left: "30%"
        },
        tooltip: {
          formatter: function(params, ticket, callback) {
            console.log(params.value);
            let v = params.value;
            return "追缴额:" + v.arrears + "元+收费额:" + v.realMoney + "元";
          }
        },
        xAxis: {
          name: "单位:元",
          nameGap: 5,
          nameTextStyle: {
            fontSize: 10
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: ["#007AF9"]
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            rotate: -60,
            formatter: function(value) {
              var texts = [];
              texts.push(value);
              return texts;
            }
          }
        },
        yAxis: {
          name: "收费员排名(月)",
          nameGap: 5,
          nameLocation: "start",
          nameTextStyle: {
            fontSize: 10
          },
          axisTick: {
            alignWithLabel: true
          },
          inverse: true,
          type: "category",
          axisLabel: {
            formatter: function(value, index) {
              let i = index + 1;
              return "{a|" + i + "}" + "{b|" + value + "}";
            },
            rich: {
              a: {
                backgroundColor: "#3395FA",
                align: "center",
                width: 16,
                height: 16,
                color: "white",
                borderRadius: 8,
                lineHeight: 16,
                fontSize: 10
              },
              b: {
                padding: [0, 5]
              }
            }
          }
        },
        series: [
          {
            type: "bar",
            barWidth: 16,
            label: {
              normal: {
                show: true,
                position: "right",
                textStyle: {
                  color: "#282828", //color of value
                  fontSize: 12
                },
                formatter: "{@total}元"
              }
            },
            emphasis: {
              label: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "#3395FA"
              }
            },
            encode: {
              // 将 "total" 列映射到 X 轴。
              x: "total",
              // 将 "name" 列映射到 Y 轴。
              y: "name"
            }
          },
          {
            type: "line",
            smooth: true,
            itemStyle: {
              color: "#FF6600"
            },
            encode: {
              // 将 "total" 列映射到 X 轴。
              x: "total",
              // 将 "name" 列映射到 Y 轴。
              y: "name"
            }
          }
        ]
      }
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    async dayEcharts() {
      if (!this.treeData.groupId) {
        this.$message({
          type: "warning",
          message: "请选择所属集团或物业"
        });
        return;
      }
      if (!this.search.day) {
        this.$message({
          type: "warning",
          message: "请选择时间"
        });
        return;
      }
      if (this.myChartInstanse) {
        this.myChartInstanse.dispose();
      }
      let datas = [];
      try {
        let result = await this.getChargeRanking(this.search.day, 1);
        datas = result.data.rows;
        if (datas.length > 0) {
          this.hasDayData = true;
        } else {
          this.hasDayData = false;
          return;
        }
      } catch (error) {
        this.hasDayData = false;
        this.$notify.error({
          title: "失败",
          message: error
        });
        return;
      }
      this.$nextTick(function() {
        this.myChartInstanse = this.$echarts.init(
          document.getElementById("myChartDay")
        );
        this.myChartDay.dataset.source = datas;
        this.myChartInstanse.setOption(this.myChartDay, true);
      });
    },
    monthEcharts: async function() {
      if (!this.treeData.groupId) {
        this.$message({
          type: "warning",
          message: "请选择所属集团或物业"
        });
        return;
      }
      if (!this.search.month) {
        this.$message({
          type: "warning",
          message: "请选择时间"
        });
        return;
      }
      if (this.myChartMonthInstanse) {
        this.myChartMonthInstanse.dispose();
      }
      let datas = [];
      try {
        let result = await this.getChargeRanking(this.search.month, "");

        datas = result.data.rows;
        console.log(datas);
        if (datas.length > 0) {
          this.hasMonthData = true;
        } else {
          this.hasMonthData = false;
          return;
        }
      } catch (error) {
        this.hasMonthData = false;
        this.$notify.error({
          title: "失败",
          message: error
        });
        return;
      }
      this.$nextTick(function() {
        this.myChartMonthInstanse = this.$echarts.init(
          document.getElementById("myChartMonth")
        );
        this.myChartMonth.dataset.source = datas;
        this.myChartMonthInstanse.setOption(this.myChartMonth, true);
      });
    },
    //点击树的节点展示相应数据
    handleTreeClick: function(node, data) {
      this.$refs.myCharts.removeAttribute("_echarts_instance_");
      //初始化日期
      this.getDate();
      this.treeData.groupId = node.id;
      this.dayEcharts();
      this.monthEcharts();
    },
    getChargeRanking(time, format) {
      return this.$get(chargeRanking(), {
        groupId: this.treeData.groupId,
        endTime: time,
        format: format
      });
    },
    //初始化年月日
    getDate() {
      let date = new Date();
      let yy = date.getFullYear();
      let mm = date.getMonth() + 1;
      if (mm.toString().length == 1) {
        mm = "0" + mm;
      }
      let dd = date.getDate();
      if (dd.toString().length == 1) {
        dd = "0" + dd;
      }
      this.search.day = yy + "-" + mm + "-" + dd;
      this.search.month = yy + "-" + mm;
    }
  },
  computed: {
    ...mapState({})
  },
  components: {
    AreaTree
  },
  created: function() {},
  mounted: function() {},
  watch: {}
};
</script>
<style scoped>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.content-right {
  position: relative;
  box-sizing: border-box;

  /* padding:0 20px 0 30px; */
}
.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
}
.chart-info {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
}
.chart-legend {
  display: block;
  width: 42px;
  height: 16px;
  background: #3395fa;
  border-radius: 8px;
  margin-right: 20px;
}
.chart-show {
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: space-around;
  box-sizing: border-box;
  margin-top: 2%;
}
.chart-show-container {
  /* height:100%; */
  width: 47%;
}
.search {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.search-input {
  width: 40%;
  /* border: 1px solid #bebebe; */
  border-radius: 5px !important;
  height: 34px;
  margin-right: 20px;
}
.search-button {
  width: 15%;
  height: 34px;
  background: #007af9;
}
</style>